
import { Placement } from '@post-office/placements-frontend/projects-screen-space-flags';
export default Placement;
